import {
  APB,
  ACROSS_LOGO,
  AUTH_GRAPHICS,
  APB_ILLUSTRATION,
} from "../../assets";
import React from "react";
import authStyles from "./styles";
import { Col } from "react-bootstrap";
import { getLanguage } from "../../utils/localization";
import { Box, Paper, Typography } from "@mui/material";

const AuthLayout = ({ children }) => {
  return (
    <Box sx={{ ...authStyles.root, backgroundImage: `url(${AUTH_GRAPHICS})` }}>
      <Paper elevation={3} sx={authStyles.paper}>
        <Box sx={authStyles.leftSection}>
          <Col xs={6} md={6} className="d-flex align-items-center">
            <img
              alt="Apb Logo"
              className="img-fluid me-3"
              src={APB}
              width={150}
            />
            <img
              alt="Across Logo"
              className="img-fluid"
              src={ACROSS_LOGO}
              width={150}
            />
          </Col>

          <Typography variant="body2" sx={authStyles.SubTitle}>
            {getLanguage("AUTH_LNG.BFMS_TWO")}
          </Typography>

          <Col>
            <img
              alt="Across Logo"
              className="img-fluid"
              src={APB_ILLUSTRATION}
              width={300}
            />
          </Col>

          <Typography variant="body2" sx={authStyles.footerText}>
            {getLanguage("AUTH_LNG.CPRYT")}
          </Typography>
        </Box>

        <Box sx={authStyles.rightSection}>{children}</Box>
      </Paper>
    </Box>
  );
};

export default AuthLayout;
